import { network } from 'services/network';

import { QueryParams } from 'api/queries/getCommonResources.query';

export const getCommonObjectsList = (params: QueryParams) => {
    return network
        .post('api/bo/management/getCommonObjectsList', {
            objectsList: params.objectsList,
            projectId: params.projectId,
        })
        .then((response) => {
            return response.data;
        });
};
